/* RM 2026-09-07: product-card image slider (3 images, swipe + dots).

   TWO BUGS FIXED HERE, both reported by Brady as "sliding does not work":

   1. Slides 2 and 3 had no src. They were hydrated by an IntersectionObserver that did
      not fire reliably even with the card centred in the viewport, so a swipe revealed
      blank white. That indirection is gone - slides are hydrated on init and the images
      keep loading="lazy", so the BROWSER decides what to defer. Do not reintroduce
      IO-gated hydration without testing a real swipe on a real viewport.

   2. The swipe never reached the track at all. .grid-product__link carries an ::after
      with position:absolute and inset:0 - the "stretched link" that makes the whole card
      clickable - and it covered the image above this slider. Every drag was a link drag.
      Fixed with z-index:1 on .rm-cs in the stylesheet.

   Because that z-index puts the slider over the stretched link across the image area,
   tap-to-open-product had to be rebuilt here: a touch or click that does not travel more
   than 8px is treated as a tap and navigates to the card's own href. Drags scroll, taps
   navigate, dots change image, and the quick-add button (z-index 5) stays above
   everything.

   The tag that loads this file is emitted per card, so the browser fetches it once but
   this script may be evaluated more than once - hence the guard below. */
(function(){
  if (window.__rmCardSlider) return;
  window.__rmCardSlider = true;

  var TAP_SLOP = 8;

  function hydrate(cs){
    var imgs = cs.querySelectorAll('img[data-rm-src]');
    for (var i = 0; i < imgs.length; i++) {
      var img = imgs[i];
      var ss = img.getAttribute('data-rm-srcset');
      if (ss) img.setAttribute('srcset', ss);
      img.setAttribute('src', img.getAttribute('data-rm-src'));
      img.removeAttribute('data-rm-src');
      img.removeAttribute('data-rm-srcset');
    }
  }

  function count(cs){ return cs.querySelectorAll('[data-rm-cs-go]').length || 1; }

  function update(cs){
    var track = cs.querySelector('[data-rm-cs-track]');
    var dots = cs.querySelectorAll('[data-rm-cs-go]');
    if (!track || !dots.length) return;
    var w = track.clientWidth || 1;
    var i = Math.round(track.scrollLeft / w);
    if (i < 0) i = 0;
    if (i > dots.length - 1) i = dots.length - 1;
    for (var d = 0; d < dots.length; d++) {
      if (d === i) dots[d].classList.add('is-active');
      else dots[d].classList.remove('is-active');
    }
  }

  function goTo(cs, track, i, smooth){
    var n = count(cs);
    if (i < 0) i = 0;
    if (i > n - 1) i = n - 1;
    var left = i * track.clientWidth;
    if (smooth && track.scrollTo) track.scrollTo({ left: left, behavior: 'smooth' });
    else track.scrollLeft = left;
    update(cs);
  }

  function hrefFor(cs){
    var card = cs.closest ? cs.closest('.grid-product') : null;
    var link = card ? card.querySelector('.grid-product__link') : null;
    return link ? link.getAttribute('href') : null;
  }

  /* drag anywhere along the dots to scrub through the images */
  function bindDots(cs, track){
    var dots = cs.querySelector('.rm-cs__dots');
    if (!dots) return;
    var dragging = false;

    function indexAt(clientX){
      var r = dots.getBoundingClientRect();
      var n = count(cs);
      if (n < 2) return 0;
      var pct = (clientX - r.left) / Math.max(r.width, 1);
      return Math.round(pct * (n - 1));
    }

    dots.addEventListener('pointerdown', function(e){
      dragging = true;
      dots.classList.add('is-dragging');
      try { dots.setPointerCapture(e.pointerId); } catch(_){}
      goTo(cs, track, indexAt(e.clientX), false);
      e.preventDefault();
      e.stopPropagation();
    });

    dots.addEventListener('pointermove', function(e){
      if (!dragging) return;
      goTo(cs, track, indexAt(e.clientX), false);
      e.preventDefault();
      e.stopPropagation();
    });

    function end(e){
      if (!dragging) return;
      dragging = false;
      dots.classList.remove('is-dragging');
      try { dots.releasePointerCapture(e.pointerId); } catch(_){}
      e.stopPropagation();
    }
    dots.addEventListener('pointerup', end);
    dots.addEventListener('pointercancel', end);
    dots.addEventListener('click', function(e){ e.preventDefault(); e.stopPropagation(); });
  }

  /* touch: let the browser scroll natively, but tell a tap from a swipe so a tap can
     still open the product (the slider now sits over the card's stretched link) */
  function bindTouchTap(cs, track){
    var sx = 0, sy = 0, moved = false;
    track.addEventListener('touchstart', function(e){
      var t = e.changedTouches[0];
      sx = t.clientX; sy = t.clientY; moved = false;
    }, { passive: true });
    track.addEventListener('touchmove', function(e){
      var t = e.changedTouches[0];
      if (Math.abs(t.clientX - sx) > TAP_SLOP || Math.abs(t.clientY - sy) > TAP_SLOP) moved = true;
    }, { passive: true });
    track.addEventListener('touchend', function(e){
      if (moved) return;
      if (e.target && e.target.closest && e.target.closest('.rm-cs__dots')) return;
      var href = hrefFor(cs);
      if (href) window.location.href = href;
    }, { passive: true });
  }

  /* desktop has no swipe: drag the image with the mouse, and a plain click opens the
     product just as clicking the card used to */
  function bindMouse(cs, track){
    var down = false, startX = 0, startY = 0, startScroll = 0, moved = false;
    track.addEventListener('pointerdown', function(e){
      if (e.pointerType && e.pointerType !== 'mouse') return;
      down = true; moved = false;
      startX = e.clientX; startY = e.clientY;
      startScroll = track.scrollLeft;
      track.classList.add('is-grabbing');
    });
    track.addEventListener('pointermove', function(e){
      if (!down) return;
      var dx = e.clientX - startX;
      if (Math.abs(dx) > 3 || Math.abs(e.clientY - startY) > 3) moved = true;
      track.scrollLeft = startScroll - dx;
      e.preventDefault();
    });
    function end(){
      if (!down) return;
      down = false;
      track.classList.remove('is-grabbing');
      if (moved) goTo(cs, track, Math.round(track.scrollLeft / (track.clientWidth || 1)), true);
    }
    track.addEventListener('pointerup', end);
    track.addEventListener('pointerleave', end);
    track.addEventListener('pointercancel', end);

    track.addEventListener('click', function(e){
      if (e.target && e.target.closest && e.target.closest('.rm-cs__dots')) return;
      if (moved) { moved = false; return; }
      var href = hrefFor(cs);
      if (href) window.location.href = href;
    });
  }

  function init(){
    var all = document.querySelectorAll('[data-rm-cs]');
    for (var i = 0; i < all.length; i++) {
      (function(cs){
        if (cs.getAttribute('data-rm-cs-init')) return;
        cs.setAttribute('data-rm-cs-init', '1');

        var track = cs.querySelector('[data-rm-cs-track]');
        if (!track) return;

        hydrate(cs);

        var t;
        track.addEventListener('scroll', function(){
          clearTimeout(t);
          t = setTimeout(function(){ update(cs); }, 60);
        }, { passive: true });

        cs.addEventListener('click', function(ev){
          var b = ev.target && ev.target.closest ? ev.target.closest('[data-rm-cs-go]') : null;
          if (!b) return;
          ev.preventDefault();
          ev.stopPropagation();
          goTo(cs, track, parseInt(b.getAttribute('data-rm-cs-go'), 10) || 0, true);
        });

        bindDots(cs, track);
        bindTouchTap(cs, track);
        bindMouse(cs, track);
      })(all[i]);
    }
  }

  function ready(fn){
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function(){
    init();
    if (window.MutationObserver) {
      var pending;
      new MutationObserver(function(){
        clearTimeout(pending);
        pending = setTimeout(init, 80);
      }).observe(document.body, { childList: true, subtree: true });
    }
  });
})();
